<template>
    <b-modal id="reset-password-modal" centered header-bg-variant="primary" @ok="resetPassword">

        <div slot="modal-header" class="w-100">
            <h2 class="text-center">Reset Password</h2>
        </div>

        <p>Please enter your email address</p>

        <b-form-group
                id="fieldset1"
                label-for="reset-password-input"
                :invalid-feedback="invalidEmailFeedback"
                :valid-feedback="validEmailFeedback"
                f :state="emailState"
        >
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="reset-password-input" placeholder="Enter email" :state="emailState"
                              v-model.trim="email"></b-form-input>
            </b-input-group>
        </b-form-group>

        <div slot="modal-ok">Confirm</div>
    </b-modal>
</template>

<script>
    export default {
        name: "Modal",

        data() {
            return {
                email: "",
            }
        },

        computed: {
            emailState() {
                let re = /[^\s@]+@[^\s@]+\.[^\s@]+/;
                return re.test(this.email);
            },
            invalidEmailFeedback() {
                if (this.email.length > 0) {
                    return "Your email is not formatted properly.";
                } else {
                    return 'Email must not be empty'
                }
            },
            validEmailFeedback() {
                return this.emailState === true ? 'Your email is formatted properly.' : ''
            },
        },

        methods: {
            resetPassword(bvEvt) {
                this.$axios({
                    method: 'get',
                    url: '/reset-password',
                    params: {
                        'email': this.email,
                    },
                    timeout: 10000
                }).then(response => {
                    this.$root.$emit('showInfo', response.data);
                    this.$root.$emit('bv::show::modal', 'info-modal');
                }).catch((err) => {
                    this.$root.$emit('showError', 'The email could not be sent');
                    this.$root.$emit('bv::show::modal', 'error-modal');
                });
            },
        }

    }
</script>
